export default __webpack_public_path__ + "locales/de/SocialAuthWelcomeDialog.json?hash=59f05d5125552d2c678bc955d1d9a482";